/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { isArrayNotEmpty } from "utils/empty-exists";

const SelectFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const values = field?.values;

    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const value = item?.value;
                    const settings = item?.settings;
                    const style = settings?.style;
                    return (
                        <DisplayTextOnly
                            key={index}
                            value={value}
                            style={style}
                        />
                    );
                })
            }
        </FieldDisplayWrapper>
    );
};
SelectFieldDisplay.displayName = "SelectFieldDisplay";
export { SelectFieldDisplay };
